exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tree-border[data-v-2028256b] { border: 1px solid #e4e7ed; border-radius: 4px; padding: 10px; background: #fff;\n}\n.custom-tree-node[data-v-2028256b] { display: -webkit-box; display: -ms-flexbox; display: flex; -webkit-box-align: center; -ms-flex-align: center; align-items: center; width: 100%; font-size: 14px;\n}\n.disabled-tree-node[data-v-2028256b] { color: #909399 !important; cursor: not-allowed !important; font-style: italic;\n}\n.disabled-tree-node[data-v-2028256b]:hover { background-color: transparent !important;\n}\n.disabled-lock-icon[data-v-2028256b] { margin-left: 8px; color: #909399; font-size: 14px;\n}\n", ""]);

// exports
